<template>
  <div class="container bg-white py-4 min-vh-100">
    <div class="text-center font-weight-bold">
      {{title}}
    </div>
    <div v-if="content.content" v-html="contentHtml">
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "xieYi",
    data() {
      return {
        content: {},
        contentHtml: {},
        loading: false,
        idType:'',
        title:'《安丘专技教育服务协议》',
      }
    },
    computed: {
      ...mapState({
        param: state => state.page
      })
    },
    mounted() {
      this.idType = this.$route.params['id'];
      if(this.$route.query['title']) {
        this.title = this.$route.query['title'];
      }
      this.getContentInfo();
    },
    methods: {
      getContentInfo() {
        this.loading = true;
        this.param.categoryId = this.idType;
        this.param.count = false;
        this.param.defaultCount= true;
        this.$store.dispatch('searchContentPublished',this.param).then((result)=>{
          if (result.list && result.list.length > 0) {
            this.content = result.list[0];
            if (this.content.content) {
              this.$store.dispatch('getContent', {content:this.content.content}).then((result) => {
                this.loading = false;
                this.contentHtml = result;
              })
            }
          }
        })
      }
    }
  }
</script>

<style>

</style>
